// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__16Nsz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__UyjqZ"};